import { User } from "../@core/data/users";

export default class Comment {
  id?: string;
  mode?: string;
  refId?: string;
  refTitle?: string;
  refUid?: string;
  refAuthor?: User;
  refUrl?: string;

  content?: string;
  privacy?: boolean;

  level?: number;
  toId?: string;
  toUid?: string;
  toAuthor?: User;

  noLiked?: number;
  noReplied?: number;

  //render/editing
  editing?: boolean;
  loading?: boolean;
  moreRefTitle?: boolean;

  iconType?: string;
  preTitle?: string;
  iconMode?: string;
  navigateUrl?: string;

  //Moderator
  isReviewed?: boolean;
  isApproved?: boolean;
  approvedOn?: Date;
  approvedBy?: string;
  approvedAuthor?: User;

  //default
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  accessToken?: string;
}
